<template>
    <div class="main">
        <div class="daohang">
            <el-menu active-text-color="#ffd04b" background-color="#3d5a47" class="el-menu-vertical-demo"
                text-color="#fff" @open="handleOpen" @close="handleClose" :default-openeds="['1', '2']"
                :default-active="$route.path" router>
                <el-sub-menu index="1">
                    <template #title>
                        <el-icon>
                            <location />
                        </el-icon>
                        <span>邑学宝管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/yxb/lunbo">轮播图</el-menu-item>
                        <el-menu-item index="/yxb/uni-inform">首页公告</el-menu-item>
                        <el-menu-item index="/yxb/community">社区帖子</el-menu-item>
                        <el-menu-item index="/yxb/community-pictures">帖子图片</el-menu-item>
                        <el-menu-item index="/yxb/users">小程序用户</el-menu-item>
                        <el-menu-item index="/yxb/tongji">访问统计</el-menu-item>
                        <el-menu-item index="/yxb/data-console">资料·分类·订单</el-menu-item>
                        <el-menu-item index="/yxb/files">文件管理(yxb_wx)</el-menu-item>
                        <el-menu-item index="/yxb/mediasec">多媒体检测管理</el-menu-item>
                        <el-menu-item index="/yxb/news">系统消息</el-menu-item>
                    </el-menu-item-group>
                </el-sub-menu>

                <el-sub-menu index="2">
                    <template #title>
                        <el-icon>
                            <location />
                        </el-icon>
                        <span>设置</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/">工具箱首页</el-menu-item>
                        <el-menu-item index="logout" @click="out">退出登录</el-menu-item>
                    </el-menu-item-group>
                </el-sub-menu>
            </el-menu>
        </div>
        <div class="xuanxiangka">
            <div style="width: 100%">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "YxbIndexView",
    data() {
        return {
            role: sessionStorage.getItem("role"),
        };
    },
    methods: {
        out() {
            sessionStorage.removeItem("usercode");
            sessionStorage.removeItem("role");
            sessionStorage.setItem("s", false);
            this.$router.replace("/login");
        },
        handleOpen() { },
        handleClose() { },
    },
};
</script>

